/**
 * @desc 导出异常单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/exportAbnormal`, {
      method: "GET",

      ...options,
    }),
  );
}
